import Image from 'next/image';
import {
  TypeImage,
  TypeImageFields,
  TypeVideoFields,
} from '@/core/generated-types';
import { Entry } from 'contentful';
import { Video } from '@/components/ui';
import classNames from 'classnames';
import { RefObject } from 'react';

export function getImageSrc(image: TypeImage) {
  return image?.fields?.Image?.fields?.file?.url;
}

export function isVideo(media: Entry<TypeImageFields | TypeVideoFields>) {
  return media?.fields && 'video' in media?.fields;
}

export function getMediaComponent(
  media: Entry<TypeImageFields | TypeVideoFields>,
  classes = '',
  autoplay = false,
  ref?: RefObject<HTMLVideoElement> | RefObject<HTMLImageElement>,
) {
  if (isVideo(media)) {
    const videoSrc =
      (media?.fields as TypeVideoFields)?.video?.fields?.file?.url ?? '';

    if (videoSrc === '') return null;

    return (
      <Video
        classes={classNames(`${classes} object-cover`)}
        src={videoSrc}
        autoplay={autoplay}
        ref={ref as RefObject<HTMLVideoElement>}
      />
    );
  }

  const imageMedia = media as TypeImage;
  const imageSrc = getImageSrc(imageMedia);
  // Note: Next's Image requires an explicit protocol. In the event one isn't present, we must prepend it.
  const safeImageSrc = imageSrc.includes('http')
    ? imageSrc
    : `https:${imageSrc}`;

  return (
    <Image
      alt={imageMedia.fields.altText}
      aria-hidden
      className={classNames(`${classes} object-cover`)}
      fill
      priority
      src={safeImageSrc}
      ref={ref as RefObject<HTMLImageElement>}
    />
  );
}
